/**
 * 生徒テスト一覧取得API
 */
import { Component, Vue } from 'vue-property-decorator'
import { ApiResponseStudentStudyContent } from '@/models/apiResponses/studentStudyContents'
import { StudyContentSetting } from '@/const/ApiSettings'

@Component
export default class StudentStudyContentsApi extends Vue {
  /**
   * 生徒テスト一覧取得
   * @param years 実施年度
   * @param month 実施月
   * @param gradeId 学年ID
   * @returns 生徒テスト一覧
   */
  protected async getStudentStudyContents(
    years: number,
    month: number,
    gradeId: number
  ): Promise<ApiResponseStudentStudyContent[]> {
    const { data }: { data: ApiResponseStudentStudyContent[] } = await Vue.prototype.$http.httpWithToken
      .get('/v2/student/study_contents/search', {
        params: {
          years: years,
          month: month,
          grade: gradeId,
          functionType: StudyContentSetting.DEFAULT_FUNCTION_TYPE,
          studyMode: StudyContentSetting.DEFAULT_STUDY_MODE,
        },
      })
      .catch(() => ({ data: [] }))

    return data
  }

  /**
   * 生徒履歴テスト一覧取得
   * @param years 実施年度
   * @param month 実施月
   * @param gradeId 学年ID
   * @returns 生徒履歴テスト一覧
   */
  protected async getStudentStudyResultContents(
    years: number,
    month: number,
    gradeId: number
  ): Promise<ApiResponseStudentStudyContent[]> {
    const { data }: { data: ApiResponseStudentStudyContent[] } = await Vue.prototype.$http.httpWithToken
      .get('/v2/student/study_contents/search_with_result_drill', {
        params: {
          years: years,
          month: month,
          grade: gradeId,
          functionType: StudyContentSetting.DEFAULT_FUNCTION_TYPE,
          studyMode: StudyContentSetting.DEFAULT_STUDY_MODE,
        },
      })
      .catch(() => ({ data: [] }))

    return data
  }
}
